export default __webpack_public_path__ + "static/media/LogoAndTitle.915929cc.svg";